module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "ch01"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p9"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiSteinbeckupdate0006#toc"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("The South Side Scene")]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "data-locator": "p9"
    }
  }), _vm._v("We realized that we all had this vital thing in common, which was the spirit of searching."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en20",
      "id": "en20r"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0101"
    }
  }, [_vm._v("Sweet Home Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("For over forty years, the members of the Art Ensemble carried their city’s name with pride, declaring to the whole world that there was no place like Chicago. Indeed, the Art Ensemble could not have emerged anywhere else. During the middle of the twentieth century, Chicago was widely regarded as the “capital of black America.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en21",
      "id": "en21r"
    }
  }, [_vm._v("2")])]), _vm._v(" It was home to more African Americans than any metropolitan area but New York. The South Side of Chicago, in fact, had a larger black population than Harlem."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en22",
      "id": "en22r"
    }
  }, [_vm._v("3")])]), _vm._v(" Many of the nation’s most influential African American politicians, business leaders, writers, and artists were based in Chicago. And the city’s music scene was second to none. The spirited performances of South Side church musicians like Mahalia Jackson and Thomas Dorsey made gospel music a national phenomenon."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en23",
      "id": "en23r"
    }
  }, [_vm._v("4")])]), _vm._v(" After World War II, the local circuit of nightclubs and recording studios drew the best blues singers from the Mississippi Delta to Chicago."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en24",
      "id": "en24r"
    }
  }, [_vm._v("5")])]), _vm._v(" Jazz, too, was an integral part of the Chicago music scene. At midcentury, the South Side boasted some seventy-five jazz venues, even more than in the Roaring Twenties, when a young Louis Armstrong "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p10"
    }
  }), _vm._v("was Chicago’s brightest star."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en25",
      "id": "en25r"
    }
  }, [_vm._v("6")])]), _vm._v(" In the 1960s, Chicago became a crucial staging ground for the Black Arts Movement, as African American organizations across the country worked to achieve social change through the arts."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en26",
      "id": "en26r"
    }
  }, [_vm._v("7")])]), _vm._v(" The Art Ensemble emerged from one of Chicago’s foremost black arts organizations, the Association for the Advancement of Creative Musicians (AACM). From the AACM, the members of the Art Ensemble learned not only musical techniques but also the social practices that sustained them from the 1960s into the twenty-first century. In other words: without Chicago, the South Side music scene, and the AACM, there would have been no Art Ensemble.")]), _vm._v(" "), _c('p', [_vm._v("Likewise, the community that gave rise to the Art Ensemble could not have come to be without the Great Migration. From the early twentieth century to the 1970s, six million African Americans left the South and resettled elsewhere in the United States. Some moved to the West Coast, but most traveled northward, and the greatest number of migrants headed to the booming cities of the industrial North."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en27",
      "id": "en27r"
    }
  }, [_vm._v("8")])]), _vm._v(" No northern city was affected more by the Great Migration than Chicago. In 1900, there were only thirty thousand African Americans in Chicago, less than two percent of the city’s population."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en28",
      "id": "en28r"
    }
  }, [_vm._v("9")])]), _vm._v(" Over the next three decades, nearly two hundred thousand black Southerners came to Chicago, with the majority arriving during World War I and the 1920s."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en29",
      "id": "en29r"
    }
  }, [_vm._v("10")])]), _vm._v(" The rate of migration slowed in the 1930s, as the Depression made it difficult for newcomers to find work."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en30",
      "id": "en30r"
    }
  }, [_vm._v("11")])]), _vm._v(" When the United States entered World War II, the economy began to grow again, setting off a second wave of mass migration from the South. In the three decades that followed, another five hundred thousand African American migrants entered Chicago, and the local black community swelled to more than a million, one-third of the city’s population."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en31",
      "id": "en31r"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', [_vm._v("Prior to the Great Migration, most black Chicagoans lived along the State Street corridor, a narrow strip of land extending southward from 22nd Street. When migrants from the South began to stream into Chicago, the city’s black residential area expanded, though not fast enough to keep pace with the ever-increasing population. By 1930, a few isolated enclaves had developed elsewhere in Chicago, but the vast majority of African Americans resided in the South Side “black belt”—still centered on State Street, now a little more than a mile wide from west to east (Wentworth Avenue to Cottage Grove Avenue), and five miles long from north to south (22nd Street to 63rd Street)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en32",
      "id": "en32r"
    }
  }, [_vm._v("13")])]), _vm._v(" This territorial expansion was not achieved without a struggle. White realtors and property owners used restrictive covenants to prevent African Americans from purchasing or leasing homes in certain neighborhoods. With the housing supply artificially constricted, the black belt became overcrowded and overpriced."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en33",
      "id": "en33r"
    }
  }, [_vm._v("14")])]), _vm._v(" In Chicago, the boundary lines between white and black spaces were "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p11"
    }
  }), _vm._v("sharply drawn, and stepping across a border could be dangerous, even deadly. During the summer of 1919, the city erupted in a weeklong race riot after a black teenager was killed for swimming too close to a whites-only beach."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en34",
      "id": "en34r"
    }
  }, [_vm._v("15")])]), _vm._v(" Racial violence also broke out in the neighborhoods, especially those adjacent to the black belt. White gangs guarded their turf against all trespassers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en35",
      "id": "en35r"
    }
  }, [_vm._v("16")])]), _vm._v(" And when black families managed to buy or rent property in districts dominated by whites, their new neighbors resisted fiercely. From the 1910s to the 1950s, African Americans who moved into contested areas saw their homes mobbed, firebombed, and burned to the ground."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en36",
      "id": "en36r"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', [_vm._v("The African American community countered segregation and intimidation by building vibrant institutions across the South Side: social clubs, churches, top-notch public schools, and businesses of all kinds."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en37",
      "id": "en37r"
    }
  }, [_vm._v("18")])]), _vm._v(" To its residents, the black belt seemed like “a city within a city,” a world unto itself."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en38",
      "id": "en38r"
    }
  }, [_vm._v("19")])]), _vm._v(" And life in the place they called Bronzeville could be wondrous, particularly for those who had a few dollars to spare. Recent arrivals from the South were able to establish themselves quickly, often with the assistance of family and friends from back home who had preceded them to Chicago."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en39",
      "id": "en39r"
    }
  }, [_vm._v("20")])]), _vm._v(" In some ways, it was as if African American migrants had never left the South. Instead, they brought southern culture to the North."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en40",
      "id": "en40r"
    }
  }, [_vm._v("21")])]), _vm._v(" On any Saturday night in Bronzeville, black Chicagoans could dine at restaurants that served southern food or socialize at nightclubs that featured down-home music."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en41",
      "id": "en41r"
    }
  }, [_vm._v("22")])]), _vm._v(" Then, on Sunday morning, they could attend churches where the style of worship—and sometimes the minister and whole congregation—had been imported directly from the South."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en42",
      "id": "en42r"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', [_vm._v("Bronzeville offered much more than northern echoes of southern folkways. By midcentury, the black belt had a larger population than “all but eighteen . . . cities of the United States,” and its citizens had access to every amenity and attraction of a modern metropolis."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en43",
      "id": "en43r"
    }
  }, [_vm._v("24")])]), _vm._v(" The "), _c('i', [_vm._v("Chicago Defender")]), _vm._v(", Bronzeville’s renowned African American newspaper, was read throughout the nation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en44",
      "id": "en44r"
    }
  }, [_vm._v("25")])]), _vm._v(" South Side residents could attend professional sporting events, shop at well-appointed department stores, and watch the latest Hollywood features at cinemas that seated thousands."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en45",
      "id": "en45r"
    }
  }, [_vm._v("26")])]), _vm._v(" In the nighttime, the action shifted to the broad sidewalks of “the Stroll,” a bustling commercial district initially centered at 35th Street, and subsequently at 47th Street."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en46",
      "id": "en46r"
    }
  }, [_vm._v("27")])]), _vm._v(" Many of the businesses along the Stroll were open around the clock, drawing crowds in which locals rubbed shoulders with visitors “from all over the world. . . . just like Times Square.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en47",
      "id": "en47r"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', [_vm._v("The sheer visual spectacle was part of the Stroll’s appeal, but the main event was live music. According to Malachi Favors, a proud Bronzeville native and a future member of the Art Ensemble, “Chicago had the greatest entertainment section in the world, right there on the South Side.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en48",
      "id": "en48r"
    }
  }, [_vm._v("29")])]), _vm._v(" During the early years "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p12"
    }
  }), _vm._v("of the Great Migration, the premier nightclubs were located near 35th and State, the heart of the Stroll."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en49",
      "id": "en49r"
    }
  }, [_vm._v("30")])]), _vm._v(" As Bronzeville expanded, a number of new venues opened to the south, where the population was growing the fastest. In the late 1920s, when the Stroll moved to 47th Street and South Parkway (later Martin Luther King Jr. Drive), it was anchored by the three-thousand-seat Regal Theater and the mammoth six-thousand-seat Savoy Ballroom."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en50",
      "id": "en50r"
    }
  }, [_vm._v("31")])]), _vm._v(" After World War II, African Americans gained entry to residential neighborhoods on the periphery of the black belt: Englewood and Greater Grand Crossing to the south and west, as well as Oakland, Kenwood, Hyde Park, and Woodlawn, which lay east of Cottage Grove Avenue."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en51",
      "id": "en51r"
    }
  }, [_vm._v("32")])]), _vm._v(" By the 1950s, this flourishing area had become the hub of the Bronzeville music scene. The intersection of 63rd Street and Cottage Grove was encircled by more than a dozen nightclubs."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en52",
      "id": "en52r"
    }
  }, [_vm._v("33")])]), _vm._v(" As one South Sider remembered, 63rd and Cottage was a “mecca for musicians”: “You didn’t need to go in a joint to hear some music . . . you could [listen] just walking up and down the street.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en53",
      "id": "en53r"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', [_vm._v("In the 1960s, with little warning, the South Side scene would change dramatically, a development that led to the formation of the AACM. However, for Malachi Favors, Joseph Jarman, and Roscoe Mitchell—young musicians who came of age in the 1940s and 1950s—Bronzeville was an ideal place to grow up. The tradition that they came to call “Great Black Music” was taking shape right in their neighborhoods. And all they had to do was open up their front doors and walk out into the night.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0102"
    }
  }, [_vm._v("Malachi Favors")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Rev. Isaac Favors and his wife, Maggie Mayfield Favors, came to Chicago from Lexington, Mississippi."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en54",
      "id": "en54r"
    }
  }, [_vm._v("35")])]), _vm._v(" An ambitious young couple, they had much in common with their fellow migrants. Both were born and raised in Mississippi, which sent more African Americans to Chicago than any other state."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en55",
      "id": "en55r"
    }
  }, [_vm._v("36")])]), _vm._v(" Additionally, like many migrants from the South, they were following a trail blazed by a close relative—Rev. Favors’s uncle, Elder P. R. Favors, who settled in Chicago during the 1910s."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en56",
      "id": "en56r"
    }
  }, [_vm._v("37")])]), _vm._v(" On 22 August 1927, not long after Rev. and Mrs. Favors moved to Chicago, they had a son, the first of their ten children."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en57",
      "id": "en57r"
    }
  }, [_vm._v("38")])]), _vm._v(" Instead of naming their oldest son for his father, Isaac, they chose a name belonging to a different Old Testament figure: Malachi, the “messenger” of the Lord."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en58",
      "id": "en58r"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', [_vm._v("The Favors and Mayfield families were among the earliest members of the Church of God in Christ (COGIC), a Protestant denomination founded in "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p13"
    }
  }), _vm._v("Lexington, Mississippi, by Charles Harrison Mason."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en59",
      "id": "en59r"
    }
  }, [_vm._v("40")])]), _vm._v(" In the 1890s, Mason and several other Baptist ministers from the Mississippi Delta became involved with the Holiness movement, an outgrowth of Civil War–era Methodism. According to Holiness teaching, believers could receive the Holy Spirit in their souls and become sanctified—set apart from the world and delivered from sin. The doctrine of sanctification led Mason and his associates to split with the Baptists and form their own denomination."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en60",
      "id": "en60r"
    }
  }, [_vm._v("41")])]), _vm._v(" They also began studying the relationship between African American religious practices and the ecstatic worship of the first-century Christian church."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en61",
      "id": "en61r"
    }
  }, [_vm._v("42")])]), _vm._v(" These investigations brought Mason to the famous Azusa Street Revival in Los Angeles, where in 1907 he spoke in tongues and experienced the baptism of the Holy Spirit, like the apostles at Pentecost. When Mason returned from the Azusa Street Revival, he reorganized the Church of God in Christ as a Pentecostal assembly and moved its headquarters to Memphis, Tennessee. After the move to Memphis, Mason’s denomination took off. Thousands of converts joined the church, and Mason sent out evangelists to establish new congregations throughout the country."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en62",
      "id": "en62r"
    }
  }, [_vm._v("43")])]), _vm._v(" Elder P. R. Favors, who had served as a deacon at the “mother church” in Lexington, was dispatched to Chicago, where he started one of the city’s first COGIC congregations."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en63",
      "id": "en63r"
    }
  }, [_vm._v("44")])]), _vm._v(" In the next decade, the South Side became home to twenty more COGIC churches, including Friendly Temple, founded by Rev. Isaac Favors upon his arrival in Chicago."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en64",
      "id": "en64r"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', [_vm._v("Music played an essential role in the church where Malachi Favors was raised. All COGIC church members were expected to sing, and at a testimony service, anyone might be called to lead the entire congregation in a song. Those who demonstrated special talents were given additional opportunities to develop their voices, from singing solos during worship services to performing at revival meetings."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en65",
      "id": "en65r"
    }
  }, [_vm._v("46")])]), _vm._v(" The singing culture of the Church of God in Christ would produce some of the most celebrated vocalists of the twentieth century, beginning with the first gospel singer to cross over into popular music, Sister Rosetta Tharpe, a frequent visitor at Elder P. R. Favors’s congregation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en66",
      "id": "en66r"
    }
  }, [_vm._v("47")])]), _vm._v(" The instrumentalists in COGIC churches were just as innovative as the singers, introducing new performance practices that transformed the sound of African American religious music."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en67",
      "id": "en67r"
    }
  }, [_vm._v("48")])]), _vm._v(" As Malachi Favors observed: “The Church of God in Christ brought with it in its praise the use of all musical instruments: tambourine, guitar, you name it. . . . They completely turned around praise in this hemisphere.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en68",
      "id": "en68r"
    }
  }, [_vm._v("49")])]), _vm._v(" Sister Rosetta Tharpe, for instance, was known as much for her brilliant guitar playing as for her singing voice. However, young Malachi preferred another COGIC singer-guitarist, the itinerant evangelist Utah Smith:"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en69",
      "id": "en69r"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p14"
    }
  }), _vm._v("The first musical instrument that I ever heard played was the guitar, [by] Elder Utah Smith. He was my first idol. Everybody that picked up a guitar in the Church tried to sound like Elder Utah. The man was powerful. He could sing. He had a big baritone voice and he didn’t need a microphone."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en70",
      "id": "en70r"
    }
  }, [_vm._v("51")])])])]), _vm._v(" "), _c('p', [_vm._v("A typical preacher’s kid, Favors spent every Sunday and most weeknights at his family’s church. Outside the walls of Friendly Temple, though, he faced the same issues confronting every other working-class child in Chicago, from family finances to juvenile gangs. Favors grew up near 41st Street and Langley Avenue in the Grand Boulevard neighborhood, where “[y]ou got your reputation by dealing with your fists. I wasn’t all that good at first, but I got ran home from school a couple of times, and one time a little short guy came to my rescue. He was pretty bad, so I started running with him.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en71",
      "id": "en71r"
    }
  }, [_vm._v("52")])]), _vm._v(" Favors’s fighting days did not last long, but his toughness served him well when he entered Wendell Phillips High School, the first African American high school in the city. High school football was big in 1940s Chicago, and he joined the Phillips team, playing lineman despite being undersized for the position (at five-foot-six and a hundred and fifty pounds)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en72",
      "id": "en72r"
    }
  }, [_vm._v("53")])]), _vm._v(" In addition to sports, Favors was also into music. He and three classmates formed a “street corner doo-wop group” that debuted at the high school’s annual Spring Festival."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en73",
      "id": "en73r"
    }
  }, [_vm._v("54")])]), _vm._v(" Unfortunately, the Spring Festival was also the group’s last performance. A doo-wop quartet was only as good as its lead singer, and the group members never found a reliable tenor. They even auditioned Sam Cooke—"), _c('i', [_vm._v("the")]), _vm._v(" Sam Cooke, a fellow student at Phillips High—but he didn’t make the cut. As Favors recalled:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("It looked like the group was going to disband because the tenor William Green, he fell in love with every girl that he knew, and so that interfered with the rehearsal of the group. He would never show up because it was a new girl, so we tried to get somebody else. We tried Sam Cooke, and Sam Cooke couldn’t quite measure up to Green, so the group eventually broke up."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en74",
      "id": "en74r"
    }
  }, [_vm._v("55")])])])]), _vm._v(" "), _c('p', [_vm._v("After Favors graduated from Wendell Phillips High School, he found a job in the mail room of a firm in the Loop, Chicago’s downtown business district. Because he was still living with his family, he had few expenses, and his eight-to-five job gave him plenty of pocket money."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en75",
      "id": "en75r"
    }
  }, [_vm._v("56")])]), _vm._v(" So Favors became a “nighthawk,” spending his evenings listening to music at Bronzeville’s theaters and nightclubs."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en76",
      "id": "en76r"
    }
  }, [_vm._v("57")])]), _vm._v(" He developed a keen interest in all styles of jazz, from small-group bebop to the big-band music of Count Basie, Duke Ellington, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p15"
    }
  }), _vm._v("and Earl Hines."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en77",
      "id": "en77r"
    }
  }, [_vm._v("58")])]), _vm._v(" And no matter who was performing, Favors always paid close attention to the double bass. He heard Ellington’s mid-1940s orchestra at the Regal Theater, and was captivated by the bass playing of Junior Raglin. Some months later, when the Ellington band returned to the Regal Theater, Favors was upset when he discovered that Raglin had been replaced by another bassist, Oscar Pettiford:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("[W]hen these bands came to the Regal, they would list their personnel. This one time when I went to the Regal, I saw Oscar Pettiford and I was totally discouraged. . . . I started not to go. I said, “Man, Junior Raglin is not playing,” but I went on in and Duke Ellington was playing and Oscar Pettiford came to the mic and took a solo and that was it. I couldn’t get over that."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en78",
      "id": "en78r"
    }
  }, [_vm._v("59")])])])]), _vm._v(" "), _c('p', [_vm._v("Week by week, Favors was growing more interested in music and less committed to his day job. His coworker Louis Blackwell, a friend from Phillips High, already had one foot out the door, having taken up guitar with the aim of becoming a professional musician. He urged Favors to do the same, saying, “Man, you better get you something to do. You know you don’t like working down here.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en79",
      "id": "en79r"
    }
  }, [_vm._v("60")])]), _vm._v(" After hours, the two friends listened to records and plotted their next move. “We’d get together at night and listen to Charlie Parker and all the great jazz players,” Favors remembered. “I would just be listening to the bass and I would strum like I’m playing the bass.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en80",
      "id": "en80r"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', [_vm._v("One day, he finally decided to follow Blackwell’s advice. Favors was walking along Wabash Avenue when he came upon a shop with a double bass for sale: “I was working, so I went in there, paid down on it, and bought the bass.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en81",
      "id": "en81r"
    }
  }, [_vm._v("62")])]), _vm._v(" This purchase would change his life, not just his career path, and to him it felt almost like a religious experience. As Favors put it, “[t]he Spirit of the music has always been a part of my being, but did not manifest itself until I was in my late teen years. Then I awakened to GREAT BLACK MUSIC!”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en82",
      "id": "en82r"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', [_vm._v("Favors left the Wabash Avenue shop and brought the bass home. When he walked through the door, his father questioned him immediately:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqf"
  }, [_vm._v("“What are you going to do with that thing, boy?”")]), _vm._v(" "), _c('p', {
    staticClass: "bql"
  }, [_vm._v("I said, “I’m going to play it.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en83",
      "id": "en83r"
    }
  }, [_vm._v("64")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This reaction did not take Favors by surprise. Certain musical instruments, including Utah Smith and Rosetta Tharpe’s electric guitars, were welcome in COGIC churches. But the bass Favors carried into his parents’ apartment was "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p16"
    }
  }), _vm._v("associated with secular entertainment, and in the COGIC tradition, believers were taught to avoid playing or listening to “the Devil’s music.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en84",
      "id": "en84r"
    }
  }, [_vm._v("65")])]), _vm._v(" Rev. and Mrs. Favors did not want their son to come into conflict with the church’s teachings, and at first they tried to persuade him to quit. After a few months, however, they finally relented. Malachi’s musical pursuits did not affect his religious devotion, and he impressed his parents by diligently practicing his new instrument. If he continued to apply himself, they reasoned, he could experience greater success as a musician than as a mail-room clerk."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en85",
      "id": "en85r"
    }
  }, [_vm._v("66")])]), _vm._v(" “I guess,” Favors mused, “they were happy to see me do something.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en86",
      "id": "en86r"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', [_vm._v("With his parents’ blessing, Favors began making his way onto the South Side music scene. At a nightclub on 43rd Street, he befriended Wilbur Ware, “the most famous bass player in Chicago.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en87",
      "id": "en87r"
    }
  }, [_vm._v("68")])]), _vm._v(" Ware volunteered to serve as Favors’s teacher, but his unorthodox bass technique was difficult for a novice to emulate. And because Ware played exclusively by ear, he couldn’t help Favors learn how to read musical notation or interpret chord symbols."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en88",
      "id": "en88r"
    }
  }, [_vm._v("69")])]), _vm._v(" Eventually Favors found another instructor: Roscoe “Bali” Beach, an accomplished bassist who taught music at DuSable High, Chicago’s second African American high school."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en89",
      "id": "en89r"
    }
  }, [_vm._v("70")])]), _vm._v(" But by the time he started taking bass lessons from Beach, Favors had already become a full-fledged professional musician. He had hoped to study music intensively before venturing into the professional world. However, there was a “shortage of bass players” in Bronzeville, and he did not want to turn down gigs."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en90",
      "id": "en90r"
    }
  }, [_vm._v("71")])]), _vm._v(" So he learned on the job, rapidly acquiring the skills he needed to get by on the bandstand. Just one year after he began playing, Favors was working so much that he had to join Local 208, the African American musicians’ union:"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en91",
      "id": "en91r"
    }
  }, [_vm._v("72")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("I remember the guys walked me over to the union, which was on 39th and State, to get me to join the union, because the union representative would come around to the gigs, and if you weren’t in the union you were in trouble. I was playing when I really didn’t know what I was doing, because they called me: “Are you working?” I’d say “No.” “You want a gig?” “Yeah.” So I was out there, it was something. I think back, I don’t know how I made it."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en92",
      "id": "en92r"
    }
  }, [_vm._v("73")])])])]), _vm._v(" "), _c('p', [_vm._v("In February 1951, after playing bass professionally for some four years, Favors enlisted in the U.S. Army."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en93",
      "id": "en93r"
    }
  }, [_vm._v("74")])]), _vm._v(" At the time, the Korean War was at its height, and many American servicemen were sent to the 38th Parallel, including Favors’s younger brother Isaac Jr."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en94",
      "id": "en94r"
    }
  }, [_vm._v("75")])]), _vm._v(" In contrast, Malachi’s tour of duty "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p17"
    }
  }), _vm._v("took place much closer to home. He was assigned to a support unit at Camp Atterbury, Indiana, an infantry installation located two hundred miles south of Chicago."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en95",
      "id": "en95r"
    }
  }, [_vm._v("76")])]), _vm._v(" By all accounts, Favors’s military career was rather uneventful. He was able to visit Chicago almost every weekend."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en96",
      "id": "en96r"
    }
  }, [_vm._v("77")])]), _vm._v(" While at Camp Atterbury, he kept up his musical skills by practicing on a cello that he brought from Bronzeville: “I had a cello that I took with me, and I tuned it like a bass. All the time I was [soldiering], after I’d come back off of the field, I would go get my cello.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en97",
      "id": "en97r"
    }
  }, [_vm._v("78")])]), _vm._v(" Favors’s experience with the cello helped him develop a virtuosic technique uncommon among bassists of his generation. When his two-year stint in the army came to an end, he returned to Chicago as one of the most proficient bass players in the city."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en98",
      "id": "en98r"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', [_vm._v("Favors lost no time in resuming his performance career. By the summer of 1953, soon after his discharge from the army, he was playing a regular gig with saxophonist Paul Bascomb at the Strand Show Lounge near 63rd Street and Cottage Grove Avenue. His rhythm-section partner in the Bascomb group was Vernel Fournier, who later worked the 63rd Street nightclub circuit with Ahmad Jamal. In August 1953, Favors made his recording debut with Bascomb’s band, backing up the singer Dinah Washington, a fellow alumnus of Wendell Phillips High School. He continued to perform and record with Bascomb until the end of 1953."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en99",
      "id": "en99r"
    }
  }, [_vm._v("80")])]), _vm._v(" Favors worked as a freelance musician through the fall of 1955, when he joined trumpeter King Kolax, a veteran bandleader whose past sidemen included a young John Coltrane."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en100",
      "id": "en100r"
    }
  }, [_vm._v("81")])]), _vm._v(" Favors’s association with Kolax lasted a little more than a year."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en101",
      "id": "en101r"
    }
  }, [_vm._v("82")])]), _vm._v(" Then he was hired by the pianist Andrew Hill, a rising star on the Bronzeville jazz scene. Favors stayed with Hill from 1956 to 1959, tracking a number of 45- and 78-rpm records as well as the LP "), _c('i', [_vm._v("So in Love")]), _vm._v(", the pianist’s first album as a leader."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en102",
      "id": "en102r"
    }
  }, [_vm._v("83")])]), _vm._v(" Equally adept at timekeeping and playing countermelodies, Favors was the perfect bassist for a piano trio. After Hill’s trio dissolved, Favors found his way into another popular piano trio, led by King Fleming. In 1962, he appeared on Fleming’s album "), _c('i', [_vm._v("Stand By")]), _vm._v(", recorded for the Arco label, a subsidiary of Chess Records."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en103",
      "id": "en103r"
    }
  }, [_vm._v("84")])]), _vm._v(" The Fleming trio performed primarily on the South Side, like every group that had hired Favors in the previous ten years. By the mid-1960s, though, gigs were harder to come by, and Fleming’s sidemen had to look elsewhere for work."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en104",
      "id": "en104r"
    }
  }, [_vm._v("85")])]), _vm._v(" Favors was engaged by the pianist Reno Tondelli, who played jazz standards in the lounge of the O’Hare Airport Holiday Inn. For the first time in his career, Favors had to leave the South Side to earn a living."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en105",
      "id": "en105r"
    }
  }, [_vm._v("86")])]), _vm._v(" However, African American musicians born a decade after Favors never even had the chance to perform regularly in Bronzeville. Like their parents, who migrated from the South to "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p18"
    }
  }), _vm._v("Chicago in search of better lives, the members of this generation would have to make their own opportunities.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0103"
    }
  }, [_vm._v("Joseph Jarman")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("On 14 September 1937, in Pine Bluff, Arkansas, Eva Robinson had her first and only child. She named the boy Joseph Jarman, after his father."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en106",
      "id": "en106r"
    }
  }, [_vm._v("87")])]), _vm._v(" Mr. Jarman did not stay with the family following the birth of his son, and Ms. Robinson, who was still a teenager, had to raise Joseph herself."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en107",
      "id": "en107r"
    }
  }, [_vm._v("88")])]), _vm._v(" Pine Bluff was mired in the Depression, and like most people in her hometown, Ms. Robinson did not have much money. So she set her sights on Chicago."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en108",
      "id": "en108r"
    }
  }, [_vm._v("89")])]), _vm._v(" When World War II broke out, the U.S. government rushed to build several defense plants in Chicago, and hundreds more local manufacturers turned to war production, seemingly overnight. Faced with a labor shortage, the city’s factories opened their doors to African American women, including Ms. Robinson, who found a defense-industry job soon after migrating to Chicago."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en109",
      "id": "en109r"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', [_vm._v("Joseph Jarman was just a toddler when he came to Chicago with his mother. They were joined by her younger sister, Joseph’s aunt Mary."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en110",
      "id": "en110r"
    }
  }, [_vm._v("91")])]), _vm._v(" The family moved into a modest residence at 720 West Scott Street in the Near North Side neighborhood."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en111",
      "id": "en111r"
    }
  }, [_vm._v("92")])]), _vm._v(" Located several miles north of Bronzeville, the Near North Side was one of the only integrated areas in the entire city."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en112",
      "id": "en112r"
    }
  }, [_vm._v("93")])]), _vm._v(" When Jarman entered Schiller Elementary School, a block east of the family home, his class included both white and black students. Things changed during Jarman’s early adolescence. His family briefly relocated to Grand Boulevard, the South Side neighborhood where Malachi Favors grew up, and Jarman started getting into fights."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en113",
      "id": "en113r"
    }
  }, [_vm._v("94")])]), _vm._v(" When he returned to the Near North Side, he clashed with his old classmates at Schiller Elementary and was labeled a “bad boy.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en114",
      "id": "en114r"
    }
  }, [_vm._v("95")])]), _vm._v(" Jarman overcame his disciplinary problems by throwing himself into extracurricular activities such as the Boy Scouts. He also signed up for Junior ROTC, a program designed to prepare high school students for service in the Armed Forces. In the spring of 1952, Jarman was awarded a medal for his performance as a first-year ROTC cadet at Waller High School (later Lincoln Park High), which he attended after graduating from Schiller Elementary."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en115",
      "id": "en115r"
    }
  }, [_vm._v("96")])]), _vm._v(" Later that year, his family moved to the South Side for good, and at DuSable High, his new school, he continued to excel in Junior ROTC, winning additional medals in 1953 and 1954."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en116",
      "id": "en116r"
    }
  }, [_vm._v("97")])])]), _vm._v(" "), _c('p', [_vm._v("When Jarman arrived at DuSable High, he was especially excited about the music program, which offered the finest training of any Chicago public "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p19"
    }
  }), _vm._v("school."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en117",
      "id": "en117r"
    }
  }, [_vm._v("98")])]), _vm._v(" He had loved music all his life, thanks to his upbringing in the Robinson clan. As Jarman recalled:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("I first started becoming aware of music crawling around the living room floor. I’m very fortunate that I had this tradition in the family. Mother in the [Baptist] church singing gospel in the choir, uncle a great jazz buff telling me all about Lester Young, Charlie Parker. My aunt madly in love with people like Billy Eckstine, Paul Quinichette. And being taken out to the nightclubs and bars while these people were all playing."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en118",
      "id": "en118r"
    }
  }, [_vm._v("99")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The family’s first South Side residence was near 48th Street and St. Lawrence Avenue, only three blocks from the 47th Street Stroll."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en119",
      "id": "en119r"
    }
  }, [_vm._v("100")])]), _vm._v(" One year, in celebration of Jarman’s birthday, his uncle brought him to the Regal Theater to hear the saxophonist and blues singer Eddie “Cleanhead” Vinson, an event he never forgot: “They had big elaborate shows at that time with dancing girls, and they would have a film, and then the stage show. . . . It was such a spectacle.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en120",
      "id": "en120r"
    }
  }, [_vm._v("101")])]), _vm._v(" By the time Jarman entered DuSable, the family lived at 46th Street and Woodlawn Avenue, still close to the Stroll but also within walking distance of the jazz clubs on East 55th Street. He and his friend James Johnson would “break the rules and come all the way to 55th, where the Beehive Lounge was.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en121",
      "id": "en121r"
    }
  }, [_vm._v("102")])]), _vm._v(" Without a chaperone, they couldn’t get into the nightclub, so they stood outside and gazed at the window, hoping to catch a glimpse of the jazz musicians onstage: “We think we saw Charlie Parker. . . . whether it’s myth or reality, we don’t care, because it was so important to us.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en122",
      "id": "en122r"
    }
  }, [_vm._v("103")])])]), _vm._v(" "), _c('p', [_vm._v("James Johnson played bassoon in the DuSable High School band, and Jarman became determined to join."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en123",
      "id": "en123r"
    }
  }, [_vm._v("104")])]), _vm._v(" He wanted to take up trumpet or alto saxophone, but those instruments cost too much."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en124",
      "id": "en124r"
    }
  }, [_vm._v("105")])]), _vm._v(" He could, however, afford to play the snare drum: DuSable High owned several snare drums, and for just six dollars, he could buy two drumsticks and a practice pad for working on rudiments at home."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en125",
      "id": "en125r"
    }
  }, [_vm._v("106")])]), _vm._v(" With this small expenditure, Jarman started his percussion studies under “the incredible guidance of Captain Walter Dyett,” the director of DuSable’s music program."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en126",
      "id": "en126r"
    }
  }, [_vm._v("107")])]), _vm._v(" Capt. Dyett earned his officer’s rank while directing the 8th Army Band. Then he became an educator who “applied military rigor to the art of training young musicians,” a method that transformed talented students into polished professionals."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en127",
      "id": "en127r"
    }
  }, [_vm._v("108")])]), _vm._v(" Capt. Dyett taught in Chicago public schools for more than thirty years, primarily at DuSable High, where his pupils included Gene Ammons, Dorothy Donegan, and Johnny Hartman."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en128",
      "id": "en128r"
    }
  }, [_vm._v("109")])]), _vm._v(" In 1939, then-student Red Sanford—better known "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p20"
    }
  }), _vm._v("as Redd Foxx—was the star of the DuSable "), _c('i', [_vm._v("Hi-Jinks")]), _vm._v(", the annual musical written and directed by Capt. Dyett."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en129",
      "id": "en129r"
    }
  }, [_vm._v("110")])]), _vm._v(" Another prominent alumnus, Nat “King” Cole, left a lasting impression on the DuSable music program, according to Jarman: “[T]he thing I remember most in the music room is that Nat ‘King’ Cole had carved his name into one of the desks.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en130",
      "id": "en130r"
    }
  }, [_vm._v("111")])]), _vm._v(" In Jarman’s view, Capt. Dyett’s famous protégés owed their success to his “extraordinary example”:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("He was just an extraordinary man, also an extraordinary musician and extraordinary teacher. . . . [A]ll these very young students from this kind of rough city-life background, he had the capacity to instill in them the idea of self-realization, of self-esteem, of self-purpose. . . . And music was his vehicle to instill these qualities into his students."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en131",
      "id": "en131r"
    }
  }, [_vm._v("112")])])])]), _vm._v(" "), _c('p', [_vm._v("Jarman studied music with Capt. Dyett until 1955, the end of his junior year. Then he put his education on hold, dropping out of DuSable High School to enlist in the army."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en132",
      "id": "en132r"
    }
  }, [_vm._v("113")])]), _vm._v(" He needed to help support his family, and military service promised a steady paycheck."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en133",
      "id": "en133r"
    }
  }, [_vm._v("114")])]), _vm._v(" Moreover, the knowledge Jarman had gained through ROTC would enable him to quickly advance through the ranks, increasing his army salary. In basic training, he performed brilliantly, finishing second in his company, though he felt that he should have placed ahead of the white recruit who finished first. The newly integrated Armed Forces did not always treat African American soldiers equally, and according to Jarman, his drill sergeants “wouldn’t accept a black as number one.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en134",
      "id": "en134r"
    }
  }, [_vm._v("115")])]), _vm._v(" After basic training, he volunteered for additional training at Fort Benning, Georgia. There, he completed paratrooper training at Airborne School and proceeded directly into Ranger School for rigorous instruction in small-unit combat tactics."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en135",
      "id": "en135r"
    }
  }, [_vm._v("116")])]), _vm._v(" Once his training ended, Jarman joined a Pathfinder platoon belonging to the 11th Airborne Division. In 1956, his platoon was deployed in Southeast Asia to aid in the incipient war against communist North Vietnam. Jarman was wounded in combat, but after he recuperated, he was given the opportunity to choose his next assignment."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en136",
      "id": "en136r"
    }
  }, [_vm._v("117")])]), _vm._v(" He asked to be transferred to the 11th Airborne Division Band."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en137",
      "id": "en137r"
    }
  }, [_vm._v("118")])])]), _vm._v(" "), _c('p', [_vm._v("Jarman’s army band was stationed in Augsburg, West Germany, not far from Munich."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en138",
      "id": "en138r"
    }
  }, [_vm._v("119")])]), _vm._v(" When his transfer went through, he had just started playing alto saxophone, the instrument he originally wanted to study back in high school. The 11th Airborne Band director, in true military fashion, was willing to take on a new recruit, provided he could keep pace with the other soldiers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en139",
      "id": "en139r"
    }
  }, [_vm._v("120")])]), _vm._v(" Jarman had to learn the band’s core repertoire in just two months:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p21"
    }
  }), _vm._v("[T]he band director gave me sixty days to be able to play the basic marches. So the musicians in there, all of these men, from seven in the morning until midnight, would be on my case, and that was the greatest time, because I didn’t have but sixty days to get my stuff together. The band director knew I couldn’t play when I got there, so I had to learn. Otherwise, he was going to throw me out. So I made it. At the end of the sixty days, I was able to read the music and play the marches and stuff."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en140",
      "id": "en140r"
    }
  }, [_vm._v("121")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("On the weekends, Jarman developed his improvisation skills by playing in jazz jam sessions held in nearby Munich. By his own admission, he was “not very good”: “At least I had the audacity and nerve to get up there.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en141",
      "id": "en141r"
    }
  }, [_vm._v("122")])]), _vm._v(" However, trial and error proved to be effective teachers. Before long, he was sufficiently skilled to earn a temporary duty assignment with a jazz trio that traveled as far as Frankfurt, West Germany, to perform at American officers’ clubs."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en142",
      "id": "en142r"
    }
  }, [_vm._v("123")])])]), _vm._v(" "), _c('p', [_vm._v("In the summer of 1958, Jarman received his discharge from the army."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en143",
      "id": "en143r"
    }
  }, [_vm._v("124")])]), _vm._v(" He was anxious to return to civilian life. Military service had given him a way to stay engaged with music and learn the alto saxophone, which would become his primary instrument. But ultimately Jarman was not cut out for the army. To be an effective soldier, particularly in combat settings, Jarman had to adopt a “military attitude” that clashed with his innate “humanism.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en144",
      "id": "en144r"
    }
  }, [_vm._v("125")])]), _vm._v(" After three years in the army, he was suffering from what he described as “emotional [and] psychological problems.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en145",
      "id": "en145r"
    }
  }, [_vm._v("126")])]), _vm._v(" When he made it back to Chicago, he tried to self-medicate with alcohol and drugs, to no avail. At one point, the stress became too much to bear, and he lost his ability to speak. “The vocal apparatus wouldn’t work,” Jarman recalled. “I had internalized all of the anguish and frustration.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en146",
      "id": "en146r"
    }
  }, [_vm._v("127")])]), _vm._v(" For more than a year, he would be completely mute."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en147",
      "id": "en147r"
    }
  }, [_vm._v("128")])])]), _vm._v(" "), _c('p', [_vm._v("Jarman began to doubt that he could get well while living in Chicago. In 1959, he set out on a cross-country odyssey, roaming from New York City to California, the Great Lakes to the Rio Grande, in search of experiences that would help him speak again."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en148",
      "id": "en148r"
    }
  }, [_vm._v("129")])]), _vm._v(" One fateful night, he found himself in El Paso, a border town where he heard a saxophonist playing “really powerful, heavy alto, Texas blues.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en149",
      "id": "en149r"
    }
  }, [_vm._v("130")])]), _vm._v(" Jarman captured this pivotal encounter in a poem:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "slf"
  }, [_vm._v("El Paso - spring 1959 - i arrive on")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("the hot summer Greyhound from the East, full")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("of dust and silence. High off - pills, smack,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("other deadly joys, mute, silent and noiseless.")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("Moving through on the Texas side/niggers played jazz, blues,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p22"
    }
  }), _vm._v("drunken songs in empty sweaty bars, i")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("remember the alto player, clean like Lou")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("Donaldson and Bird, singing magic through")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("the metal tube; mexican girls, nigger,yea")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("“poor white” women sucking vamp threads")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("from the stripes on his pants. and the U.S. Army has")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("a missle school at El Paso, friend in khaki")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("invite me to the barracks; (to rest, sleep, get")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("myself together) the smack inside me feelin")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("the texas Sun. like lizards crawling through")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("my face while i pee, wetness in the desert")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("sunlight, sand and sheep dung in my hair.")]), _vm._v(" "), _c('p', {
    staticClass: "slf"
  }, [_vm._v("At first i wandered into the white distract")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("soon (as i read the signs) big loud police")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("“nigger, where you thank you going”")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("“don’t you hear us boy!”")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("i write on my pad “MUTE” “I CANNOT SPEAK”")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("bang, against my chest, night stick,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("“nigger this ain’t where you want to be,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("now about three block thata way is the")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("nigger-wetback place; understand me")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("boy”-")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("bang, night stick on my head")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("bang, leg-bang-chest again-")]), _vm._v(" "), _c('p', {
    staticClass: "slf"
  }, [_vm._v("i move away - The Texas air sweet fire")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("knowledge between the crack of my ass,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("laughter follows, i run slowly into the")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("neon pleasure of America’ biggest border")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("town, full of lust, and sin and smack.")]), _vm._v(" "), _c('p', {
    staticClass: "sll"
  }, [_vm._v("growing “pains” to self, he said, “realization”."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en150",
      "id": "en150r"
    }
  }, [_vm._v("131")])])])]), _vm._v(" "), _c('p', [_vm._v("Jarman’s account of his El Paso experience was his first attempt at poetry."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en151",
      "id": "en151r"
    }
  }, [_vm._v("132")])]), _vm._v(" In the years to come, he would write enough poems to fill an entire book."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en152",
      "id": "en152r"
    }
  }, [_vm._v("133")])]), _vm._v(" But the most important thing he took away from that night in West Texas was a renewed interest in music, which had faded when he was struck mute. The “empty sweaty bars” of El Paso were far less glamorous than venues like Bronzeville’s Regal Theater, yet he was captivated by the sounds of the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p23"
    }
  }), _vm._v("anonymous saxophonist who “[sang] magic through the metal tube.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en153",
      "id": "en153r"
    }
  }, [_vm._v("134")])]), _vm._v(" As Jarman remembered, his 1959 visit to El Paso “sort of BOOM, opened me up. It was a signal that [music] was the thing for me to do.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en154",
      "id": "en154r"
    }
  }, [_vm._v("135")])])]), _vm._v(" "), _c('p', [_vm._v("Jarman left El Paso and headed to Tucson, Arizona. He wanted to obtain psychiatric treatment at the local Veterans Administration hospital, the same facility where his uncle Theodore Robinson had convalesced after serving in World War II."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en155",
      "id": "en155r"
    }
  }, [_vm._v("136")])]), _vm._v(" While in Tucson, Jarman spent much of his time at a local public library. He formed a friendship with one of the librarians, who thought that studying Buddhism could aid him in his recovery."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en156",
      "id": "en156r"
    }
  }, [_vm._v("137")])]), _vm._v(" Although Jarman was brought up Baptist, he was intrigued by what he was hearing about Buddhism."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en157",
      "id": "en157r"
    }
  }, [_vm._v("138")])]), _vm._v(" The librarian gave him a little volume entitled "), _c('i', [_vm._v("The Teachings of the Buddha")]), _vm._v(", and Jarman found that reading the book helped him accept what he went through in the army."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en158",
      "id": "en158r"
    }
  }, [_vm._v("139")])]), _vm._v(" “That’s what Buddhism teaches you,” he explained. “You’re OK. If you want to be cool, be cool. If you want to be crazy, be crazy. There’s no gods, no demons to blame for your condition. Nobody controls your life but you.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en159",
      "id": "en159r"
    }
  }, [_vm._v("140")])])]), _vm._v(" "), _c('p', [_vm._v("After several months in Tucson, Jarman returned to the Midwest."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en160",
      "id": "en160r"
    }
  }, [_vm._v("141")])]), _vm._v(" He stopped in Chicago for a short while, then moved to Milwaukee, Wisconsin, arriving in 1960 and living there for a year. “Milwaukee,” according to Jarman, “is where I really began to come back around.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en161",
      "id": "en161r"
    }
  }, [_vm._v("142")])]), _vm._v(" He rented a room at the YMCA, practiced his saxophone, and “learned to refocus [his] energy into positive, concrete directions.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en162",
      "id": "en162r"
    }
  }, [_vm._v("143")])]), _vm._v(" He also went back to school, taking courses in philosophy at the Milwaukee Institute of Technology (later Milwaukee Area Technical College). While in Milwaukee, Jarman continued the course of psychiatric treatment that he had begun in Tucson, and at long last his speech was restored."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en163",
      "id": "en163r"
    }
  }, [_vm._v("144")])]), _vm._v(" As he recalled: “They got me to be able to talk again, and I haven’t shut my mouth since.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en164",
      "id": "en164r"
    }
  }, [_vm._v("145")])]), _vm._v(" By 1961, Jarman felt healthy enough to come home to Chicago. He returned to the South Side and enrolled in the music program at Woodrow Wilson Junior College, where he would meet Malachi Favors and another promising saxophonist in his early twenties, Roscoe Mitchell."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en165",
      "id": "en165r"
    }
  }, [_vm._v("146")])])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0104"
    }
  }, [_vm._v("Roscoe Mitchell")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Ida Carter and her husband, Roscoe Mitchell Sr., had a son on 3 August 1940. He was the second of their two children but their first son, and they named him Roscoe Jr. for his father. Roscoe Mitchell Jr. was born in Chicago, his parents’ hometown, and he grew up near 60th and State Street, just west of Washington Park, one of the largest public parks on the South Side."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en166",
      "id": "en166r"
    }
  }, [_vm._v("147")])]), _vm._v(" At the time of Mitchell’s birth, the Washington Park neighborhood formed the southern"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p24"
    }
  }), _vm._v(" boundary of the old black belt. In the 1940s and 1950s, African Americans moved into new neighborhoods to the east, south, and west of Washington Park, and the area where Mitchell was raised became the geographic center of an expanded Bronzeville."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en167",
      "id": "en167r"
    }
  }, [_vm._v("148")])]), _vm._v(" During daylight hours, black Chicagoans gathered in Washington Park for sporting events and other diversions, and at dusk, they headed a few blocks south of the park to listen to live music at the nightclubs surrounding 63rd Street and Cottage Grove."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en168",
      "id": "en168r"
    }
  }, [_vm._v("149")])]), _vm._v(" Both destinations were only minutes away from Mitchell’s childhood home—everything offered by midcentury Bronzeville was at his fingertips.")]), _vm._v(" "), _c('p', [_vm._v("Young Roscoe had a number of artistic interests: movies, other strains of popular culture, even painting."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en169",
      "id": "en169r"
    }
  }, [_vm._v("150")])]), _vm._v(" But his first love was music. Indeed, Mitchell “always wanted to be a musician,” and he found inspirational figures all around, in his neighborhood as well as in the family home."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en170",
      "id": "en170r"
    }
  }, [_vm._v("151")])]), _vm._v(" Mitchell’s parents were regular churchgoers, and each week they brought him to the South Side church pastored by his uncle, Rev. Charles Commodore Carter, an ordained minister in the Spiritualist denomination."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en171",
      "id": "en171r"
    }
  }, [_vm._v("152")])]), _vm._v(" Worship services at Rev. Carter’s church were full of music, and Mitchell was fascinated by the choral selections and vocal solos performed by the members of the congregation. He also appreciated the musical qualities of his uncle’s sermons, which blended elements of speech and song."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en172",
      "id": "en172r"
    }
  }, [_vm._v("153")])]), _vm._v(" “The music in the church,” Mitchell recalled, “really had the most profound initial influence on me.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en173",
      "id": "en173r"
    }
  }, [_vm._v("154")])])]), _vm._v(" "), _c('p', [_vm._v("At home, Mitchell’s parents exposed him to a wide variety of music, which proved crucial to his development as a musician."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en174",
      "id": "en174r"
    }
  }, [_vm._v("155")])]), _vm._v(" His father enjoyed listening to jazz singers, and was something of a vocalist himself, according to Mitchell: “I guess you could group him into the [category] of singers that they call crooners. He also used to do a thing where he would imitate instruments with his voice.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en175",
      "id": "en175r"
    }
  }, [_vm._v("156")])]), _vm._v(" Roscoe Sr. hoped that his son would learn to sing, and he encouraged him to emulate the vocal styles of famous artists such as Louis Armstrong, Billie Holiday, and Nat “King” Cole."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en176",
      "id": "en176r"
    }
  }, [_vm._v("157")])]), _vm._v(" Mitchell’s listening regimen, of course, was not limited to vocal music. The family radio was often tuned to the broadcasts of Al Benson and McKie Fitzhugh, pioneering African American DJs known for diverse playlists that included rhythm-and-blues songs, jazz records, and Top 40 hits."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en177",
      "id": "en177r"
    }
  }, [_vm._v("158")])]), _vm._v(" Moreover, many of the recording artists promoted on these broadcasts could be found performing at the lounges and nightclubs around 63rd and Cottage, a mile east of the Mitchell residence. “[W]hen I grew up in Chicago,” Mitchell remembered, “not only did I listen to the same music that my parents listened to, I could go right outside of my house and go down the street, and they’d be playing there.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en178",
      "id": "en178r"
    }
  }, [_vm._v("159")])]), _vm._v(" Washington Park was another important site for musical learning. Many of the musicians "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p25"
    }
  }), _vm._v("in Mitchell’s neighborhood liked to practice their instruments in the park, and he would spend long hours with them, observing their practice routines and picking up tricks of the trade."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en179",
      "id": "en179r"
    }
  }, [_vm._v("160")])])]), _vm._v(" "), _c('p', [_vm._v("Mitchell began his formal music studies around the age of twelve."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en180",
      "id": "en180r"
    }
  }, [_vm._v("161")])]), _vm._v(" The family moved to Milwaukee temporarily, and his brother Norman Mainie came along, bringing with him an impressive collection of jazz records."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en181",
      "id": "en181r"
    }
  }, [_vm._v("162")])]), _vm._v(" “[H]e would get me to sit down and listen to them,” Mitchell recalled."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en182",
      "id": "en182r"
    }
  }, [_vm._v("163")])]), _vm._v(" Saxophone players were well represented in Norman’s record collection, from swing stalwarts like Coleman Hawkins and Lester Young to bebop innovators like James Moody and Charlie Parker."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en183",
      "id": "en183r"
    }
  }, [_vm._v("164")])]), _vm._v(" Norman was also a close friend of the South Side saxophone prodigy Nicky Hill, who was making a name for himself in the clubs at 63rd and Cottage, and he thought that his brother had the same kind of musical potential."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en184",
      "id": "en184r"
    }
  }, [_vm._v("165")])]), _vm._v(" With Norman’s support, Mitchell decided to “actually pursue an instrument.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en185",
      "id": "en185r"
    }
  }, [_vm._v("166")])]), _vm._v(" At West Division High School in Milwaukee, he began playing the clarinet, a typical starter instrument for students interested in woodwinds."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en186",
      "id": "en186r"
    }
  }, [_vm._v("167")])]), _vm._v(" Mitchell and his family soon returned to their old neighborhood in Chicago, and he continued his musical education at the city’s third African American high school, Englewood."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en187",
      "id": "en187r"
    }
  }, [_vm._v("168")])]), _vm._v(" In the course of his studies at Englewood High, he learned to play two additional woodwind instruments. The school’s dance band needed a baritone saxophonist, and Mitchell volunteered, getting his introduction to the saxophone family. By his senior year, he was ready for another challenge, so he borrowed a fellow student’s alto saxophone."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en188",
      "id": "en188r"
    }
  }, [_vm._v("169")])]), _vm._v(" He took to this instrument immediately. “[T]he alto,” Mitchell affirmed, “was the saxophone that really caught my interest.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en189",
      "id": "en189r"
    }
  }, [_vm._v("170")])]), _vm._v(" Like any musician learning a new instrument, Mitchell was looking for a role model, and he found one in his Englewood High classmate Donald Myrick, a talented saxophonist who some years later joined Earth, Wind & Fire."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en190",
      "id": "en190r"
    }
  }, [_vm._v("171")])]), _vm._v(" According to Mitchell, “Donald Myrick was an excellent musician when I met him in Chicago, and he was a big motivation for me.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en191",
      "id": "en191r"
    }
  }, [_vm._v("172")])]), _vm._v(" He continued: “I was fortunate to meet him at that time, because he was already playing the instrument in high school, and he . . . took me under his wing.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en192",
      "id": "en192r"
    }
  }, [_vm._v("173")])])]), _vm._v(" "), _c('p', [_vm._v("In 1958, Mitchell graduated from Englewood High School and enlisted in the army."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en193",
      "id": "en193r"
    }
  }, [_vm._v("174")])]), _vm._v(" Unlike Malachi Favors and Joseph Jarman, who joined the military intending to be soldiers, Mitchell’s plan from the beginning was to become an army musician. He had only been playing saxophone for a short time, but he was proficient enough to pass his audition for the prestigious U.S. Army Europe Band, one of the best service bands on the continent. Mitchell would spend almost three years with this band, which was based at the army’s European headquarters in Heidelberg, West Germany."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en194",
      "id": "en194r"
    }
  }, [_vm._v("175")])]), _vm._v(" When he arrived in "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p26"
    }
  }), _vm._v("Heidelberg, he discovered that the lifestyle of an Armed Forces specialist was much different than that of a high school music student. By his own admission, Mitchell “wasn’t really serious” about music before the army: “I played . . . but I also hung out with all my friends.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en195",
      "id": "en195r"
    }
  }, [_vm._v("176")])]), _vm._v(" In contrast, the army band offered a “full musical environment”: “[W]e’d have breakfast . . . and then there’s rehearsal until lunch time, and then after that there was another rehearsal, and if there wasn’t a gig, like going out and playing a parade or something, then there’d be caring and cleaning of instruments and individual practice.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en196",
      "id": "en196r"
    }
  }, [_vm._v("177")])])]), _vm._v(" "), _c('p', [_vm._v("During his time in Germany, Mitchell took every opportunity to advance his musical knowledge. In the U.S. Army Europe Band, he played both alto and baritone saxophone. He also developed his clarinet skills by taking lessons from the principal clarinetist of the Heidelberg Philharmonic."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en197",
      "id": "en197r"
    }
  }, [_vm._v("178")])]), _vm._v(" Additionally, Mitchell frequented the jam sessions held at the Heidelberg jazz club Cave 54, where he performed with American servicemen and met standout German musicians like Karl Berger and Albert Mangelsdorff."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en198",
      "id": "en198r"
    }
  }, [_vm._v("179")])]), _vm._v(" On a few occasions, Mitchell’s army band visited West Berlin to play in parades alongside two other Armed Forces ensembles, the West Berlin–based 298th Army Band and the 76th Army Band from Orleans, France. When their parade duties ended, the musicians who were interested in jazz would gather for after-hours jam sessions. The free-jazz saxophonist Albert Ayler, then a member of the 76th Army Band, was a regular participant in these sessions."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en199",
      "id": "en199r"
    }
  }, [_vm._v("180")])]), _vm._v(" Before Mitchell met Ayler, he had only encountered “freer form music” by listening to Ornette Coleman’s recordings with his army colleagues."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en200",
      "id": "en200r"
    }
  }, [_vm._v("181")])]), _vm._v(" At the time, Mitchell and his bandmates were “conventional” players who did not welcome Coleman’s musical experiments: “As a matter of fact, a bunch of buddies of mine, we’d make fun of Ornette’s music.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en201",
      "id": "en201r"
    }
  }, [_vm._v("182")])]), _vm._v(" They reacted in much the same way to Ayler’s improvisations at the jam sessions in West Berlin. According to Mitchell, “I remember everyone was putting him down, because we were all so obsessed with playing correctly”:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("But at this one session, Albert led off with three or four choruses of the blues and then went off into his own thing, with that awesome sound he had, and everything became clear to me. I had already heard Ornette Coleman on records and couldn’t quite grasp what he was doing. But hearing Albert live was an enlightening experience."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en202",
      "id": "en202r"
    }
  }, [_vm._v("183")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The sounds Mitchell heard that evening would stay with him for years. As he recalled: “That was my first real awakening to [the fact that] there may be another way of doing things.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en203",
      "id": "en203r"
    }
  }, [_vm._v("184")])])]), _vm._v(" "), _c('p', [_vm._v("In 1961, Mitchell received his army discharge and returned to Chicago."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en204",
      "id": "en204r"
    }
  }, [_vm._v("185")])]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p27"
    }
  }), _vm._v("He had decided to pursue music as his civilian career, but first he wanted to further his education. So he enrolled at Woodrow Wilson Junior College (later Kennedy–King College), a Chicago city college with a dynamic music program. Then located at West 71st Street and South Stewart Avenue, just three blocks from Englewood High School, Wilson Junior College attracted music students from all over the South Side. Joseph Jarman was there, as were several other young woodwind players who would become key AACM members: Anthony Braxton, Richard “Ari” Brown, and Henry Threadgill."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en205",
      "id": "en205r"
    }
  }, [_vm._v("186")])]), _vm._v(" The music program also pulled in established professionals like Malachi Favors, who came to Wilson Junior College for the opportunity to play in the orchestra and concert band."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en206",
      "id": "en206r"
    }
  }, [_vm._v("187")])])]), _vm._v(" "), _c('p', [_vm._v("Part of the college’s appeal was its low cost of attendance, especially for military veterans, whose educational expenses were subsidized by the G.I. Bill."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en207",
      "id": "en207r"
    }
  }, [_vm._v("188")])]), _vm._v(" But the main draw was Dr. Richard Wang, a music professor who directed the college’s ensembles and also taught courses in music theory. Like DuSable High School’s Capt. Dyett, Dr. Wang had a background as a jazz performer, which helped him devise a unique music curriculum that was decades ahead of its time."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en208",
      "id": "en208r"
    }
  }, [_vm._v("189")])]), _vm._v(" At most colleges and universities, professors exclusively used the European classical repertoire to teach music theory, but Dr. Wang found ways to integrate jazz and modernist composition into the Wilson Junior College curriculum. In harmony classes, his students analyzed Duke Ellington pieces like “East St. Louis Toodle-Oo” as well as the operas of Richard Wagner. And in Dr. Wang’s composition classes, students learned how to construct melodies by examining Charlie Parker’s saxophone solos alongside scores by Arnold Schoenberg."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en209",
      "id": "en209r"
    }
  }, [_vm._v("190")])])]), _vm._v(" "), _c('p', [_vm._v("Mitchell and Jarman met for the first time in one of Dr. Wang’s music-theory classes."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en210",
      "id": "en210r"
    }
  }, [_vm._v("191")])]), _vm._v(" Jarman was one of the “most assiduous” theory students at Wilson Junior College, according to Dr. Wang."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en211",
      "id": "en211r"
    }
  }, [_vm._v("192")])]), _vm._v(" Many of Mitchell’s important educational experiences, however, took place outside the theory classroom. Music students had a free period on Mondays, and Mitchell would summon his classmates to a practice room to play jazz."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en212",
      "id": "en212r"
    }
  }, [_vm._v("193")])]), _vm._v(" He tried to recruit Malachi Favors for these practice sessions, but initially the bassist turned him down. As Jarman remembered, “Malachi didn’t even speak to us, because he was in the union.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en213",
      "id": "en213r"
    }
  }, [_vm._v("194")])]), _vm._v(" Soon, however, Favors was playing in small groups with both Jarman and Mitchell."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en214",
      "id": "en214r"
    }
  }, [_vm._v("195")])]), _vm._v(" The two saxophonists also participated in the Friday-afternoon jam sessions held at the college. At these sessions, Dr. Wang’s students performed with a rotating cast of guests that included some of Bronzeville’s best professional musicians: pianists Andrew Hill and Charles Stepney, saxophonist Eddie Harris, and drummer Steve McCall."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en215",
      "id": "en215r"
    }
  }, [_vm._v("196")])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p28"
    }
  }), _vm._v("After each Friday jam session, the Wilson Junior College music department would close its doors until the following Monday, but Mitchell and Jarman did not take weekends off. They formed a jazz combo that rehearsed at Mitchell’s residence every Saturday, from mid-morning to the early evening. Mitchell and Jarman’s group played a few paid engagements at community centers and 43rd Street nightclubs, but it was primarily a rehearsal band dedicated to exploring the repertoire of Art Blakey’s early 1960s sextet."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en216",
      "id": "en216r"
    }
  }, [_vm._v("197")])]), _vm._v(" In addition to playing Blakey-style hard bop, the group investigated recent developments in modal jazz and free jazz. The musicians built study breaks into their rehearsals, during which they listened to and discussed the latest jazz albums. On one Saturday morning, according to Jarman, the drummer showed up with three “weird records”:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("One was called "), _c('i', [_vm._v("The Shape of Jazz to Come")]), _vm._v(", by this funny guy named Ornette Coleman, the other was by this guy named Eric Dolphy, and the other was by John Coltrane, but we knew he was OK because he played with Miles Davis. See, we would start playing at nine o’clock, take a break in the afternoon, then we would go back ’til six or seven at night. . . . During the break they played these three records. . . . [E]verybody was so taken by these records that when we went back and played “All the Things You Are” it had changed completely."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en217",
      "id": "en217r"
    }
  }, [_vm._v("198")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This new music may have seemed peculiar to most of the group members, but in Mitchell’s recollection, the influence of free jazz was already evident in Jarman’s saxophone playing. When Mitchell was in the army, listening to Albert Ayler helped him come to terms with the advances of Ornette Coleman. A few years later, at Wilson Junior College, Jarman gave Mitchell his “second stimulation toward freer form music”:"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en218",
      "id": "en218r"
    }
  }, [_vm._v("199")])]), _vm._v(" “Joseph Jarman . . . always played really strange to me, in a bebop-ish strange way. . . . I think he was a very good influence on me at that time.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en219",
      "id": "en219r"
    }
  }, [_vm._v("200")])])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0105"
    }
  }, [_vm._v("Experiments")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Malachi Favors, Joseph Jarman, and Roscoe Mitchell had a lot in common when their paths converged at Wilson Junior College. Although they were born in three different decades and grew up in different parts of Chicago, their musical journeys were remarkably alike. They first encountered music in their churches and at other vital neighborhood institutions. Their upbringings gave them an appreciation for the full spectrum of African American music, but "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p29"
    }
  }), _vm._v("when they discovered jazz, it was love at first sound. As Mitchell remembered, “after I started listening to jazz I didn’t want to listen to anything else anymore.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en220",
      "id": "en220r"
    }
  }, [_vm._v("201")])]), _vm._v(" They began playing instruments during their adolescent years, and continued to study jazz while serving in the Armed Forces. In 1961, the year they met at Wilson Junior College, Favors had considerably more professional experience than Jarman and Mitchell, whose musical careers had just begun. But all three were united in searching for something that they had not been able to find in the Bronzeville music scene.")]), _vm._v(" "), _c('p', [_vm._v("Jarman and Mitchell’s first forays into experimental music took place in a South Side workshop ensemble. Founded in 1961 by Eddie Harris and several other seasoned bebop players, the ensemble rehearsed weekly, first at the C&C Lounge at 63rd Street and Cottage Grove, and later at the Abraham Lincoln Center at Oakwood Boulevard and Langley Avenue. Playing in the workshop ensemble gave participants an opportunity to test out new ideas and develop skills like leading a horn section, reading unfamiliar charts, and composing adventurous music—none of which were emphasized in the nightclubs where most South Side musicians were employed."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en221",
      "id": "en221r"
    }
  }, [_vm._v("202")])]), _vm._v(" The group stayed intact until 1963, when a disagreement emerged between two of its cofounders."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en222",
      "id": "en222r"
    }
  }, [_vm._v("203")])]), _vm._v(" Trumpeter Johnny Hines wanted to remake the ensemble into a money-making venture, with the goal of becoming the house band at the Regal Theater. In contrast, pianist Richard Abrams hoped that the group would remain committed to musical experimentation, without any commercial pressures."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en223",
      "id": "en223r"
    }
  }, [_vm._v("204")])]), _vm._v(" Hines and most of the original members left the ensemble, and Abrams took over as bandleader. He was one of the group’s most prolific composers, and he had already brought a number of young South Side musicians into the ensemble, more than enough to sustain it after the departure of Hines’s clique. Now under Abrams’s direction, the workshop ensemble continued under a new name: the Experimental Band."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en224",
      "id": "en224r"
    }
  }, [_vm._v("205")])]), _vm._v(" This name would prove to be prophetic. In just a few short years, the members of the Experimental Band would transform both jazz and experimental music—not just in the city of Chicago, but around the world.")]), _vm._v(" "), _c('p', [_vm._v("Many of the younger musicians in the Experimental Band came from Wilson Junior College. The drummer Jack DeJohnette, then a student at the college, introduced Abrams to Roscoe Mitchell, who promptly joined the Experimental Band."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en225",
      "id": "en225r"
    }
  }, [_vm._v("206")])]), _vm._v(" In addition to attending the band’s regular rehearsals, Mitchell started visiting Abrams at his home near 63rd and Cottage to discuss musical composition, painting, and philosophy."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en226",
      "id": "en226r"
    }
  }, [_vm._v("207")])]), _vm._v(" Before long, Mitchell’s college classmates Joseph Jarman and Henry Threadgill followed him into the Experimental Band."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en227",
      "id": "en227r"
    }
  }, [_vm._v("208")])]), _vm._v(" As Jarman remembered, “Roscoe said, you oughta come, there’s this guy who’s got a rehearsal band”:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p30"
    }
  }), _vm._v("So I went down there and there was [Abrams], and he greets you like you were his brother or something. He said, welcome, and there were all these people in there, and I had to step back, because some of them were like famous people—local Chicago musicians, Jack DeJohnette, Scotty Holt, Steve McCall. And then this guy gave me an invitation whenever I felt like it to come by his house and get music lessons. He’d offer you herb tea and it would be so "), _c('i', [_vm._v("good")]), _vm._v(" . . . . He was into herbology, astrology, painting, all this mystical stuff that I had dreamed of. It was like I had found a teacher."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en228",
      "id": "en228r"
    }
  }, [_vm._v("209")])])])]), _vm._v(" "), _c('p', [_vm._v("Mitchell and Jarman had never encountered a teacher like Abrams. Each afternoon, they left the Wilson Junior College campus and headed straight for Abrams’s residence, where they spent hours studying music and a variety of other subjects. During Experimental Band rehearsals, their performance skills were stretched to the limit as they navigated Abrams’s complex scores."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en229",
      "id": "en229r"
    }
  }, [_vm._v("210")])]), _vm._v(" “The first rule of the band,” according to Abrams, “was that all music had to be original material,” and he brought a new composition to the ensemble virtually every week."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en230",
      "id": "en230r"
    }
  }, [_vm._v("211")])]), _vm._v(" He also asked the group members to write pieces for the Experimental Band, even though most had little to no experience as composers. Jarman, Mitchell, and their bandmates were up for the challenge, and with Abrams’s guidance, they gradually developed their own distinctive approaches to composition.")]), _vm._v(" "), _c('p', [_vm._v("Crucially, the compositional practices that emerged from the Experimental Band did not preclude improvisation. All of the ensemble members were capable jazz improvisers, and just as in mainstream jazz, the compositions played by the Experimental Band were often conceived as platforms for improvisation. However, Abrams’s insistence on constant experimentation kept the group from relying exclusively on techniques inherited from jazz or any other style."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en231",
      "id": "en231r"
    }
  }, [_vm._v("212")])]), _vm._v(" The music Abrams wrote for the ensemble drew on the compositional method invented by Joseph Schillinger, which offered composers a way of organizing musical materials according to mathematical relationships, not stylistic conventions."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en232",
      "id": "en232r"
    }
  }, [_vm._v("213")])]), _vm._v(" (At midcentury, the Schillinger system attracted adherents across the country, from composers working in commercial music, concert music, and jazz to Lawrence Berk, founder of the Berklee College of Music."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en233",
      "id": "en233r"
    }
  }, [_vm._v("214")])]), _vm._v(") In addition to studying the Schillinger system, Abrams and the other group members paid close attention to trends in contemporary experimental music. In Europe and the United States, experimentalist composers were using graphic scores to depict unconventional sounds and prompt performers to improvise—concepts that aligned precisely with the aims of the Experimental Band. The members of the Experimental Band wanted to break down the barrier between composition"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p31"
    }
  }), _vm._v(" and improvisation, and graphic notation became an indispensable resource in this critical endeavor."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en234",
      "id": "en234r"
    }
  }, [_vm._v("215")])]), _vm._v(" The ensemble’s research into new forms of musical notation led to further discoveries in the realm of conducting. As the Experimental Band delved deeper into graphic notation, Abrams devised a novel system of conducting gestures that enabled him to direct every section of a piece, from fully scored passages to open-ended improvisations."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en235",
      "id": "en235r"
    }
  }, [_vm._v("216")])]), _vm._v(" For Jarman and Mitchell, playing in Abrams’s Experimental Band was like studying at a first-rate conservatory. In Mitchell’s estimation, “I learned more from my sessions and discussions with [Abrams] than I learned from school.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en236",
      "id": "en236r"
    }
  }, [_vm._v("217")])])]), _vm._v(" "), _c('p', [_vm._v("The Experimental Band also served as a refuge during a turbulent period in the Bronzeville music scene. Since the earliest days of the Great Migration, residents of the South Side had been surrounded by live music. In the 1960s, though, everything changed. The city of Chicago began requiring nightclubs to pay an exorbitant licensing fee in order to host performances by four or more musicians."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en237",
      "id": "en237r"
    }
  }, [_vm._v("218")])]), _vm._v(" Some South Side establishments could only afford to employ smaller ensembles, while others had to hire disc jockeys, who would spin hit records all night for less than the price of a live band. The DJ format also provided a better fit with popular tastes, which were tilting away from jazz in favor of rock music and soul."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en238",
      "id": "en238r"
    }
  }, [_vm._v("219")])]), _vm._v(" Many jazz musicians lost their jobs, but for nightclub owners, this was the least of their worries. During the past five decades, the South Side entertainment industry had benefited from a continuously expanding customer base, courtesy of the Great Migration. Now this customer base was shrinking. Urban-renewal efforts decimated entire neighborhoods, and the once-mighty Bronzeville economy contracted rapidly. Countless businesses closed their doors, including most music venues and virtually every jazz club."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en239",
      "id": "en239r"
    }
  }, [_vm._v("220")])]), _vm._v(" Of course, jazz did not simply vanish from Chicago. Like Malachi Favors, who landed a gig at the O’Hare Airport Holiday Inn, some African American musicians were able to work in the suburbs or on the predominantly white North Side."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en240",
      "id": "en240r"
    }
  }, [_vm._v("221")])]), _vm._v(" Meanwhile, on the South Side, jazz went underground, surfacing only at late-night jam sessions and during the weekly rehearsals of the Experimental Band."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en241",
      "id": "en241r"
    }
  }, [_vm._v("222")])])]), _vm._v(" "), _c('p', [_vm._v("Early in 1965, Richard Abrams and three of his musician colleagues decided to found an organization that could bring music back to the South Side. All four cofounders were experienced professionals in their mid-thirties, and three were linked to the Experimental Band: Abrams directed the group, Steve McCall was its drummer, and pianist Jodie Christian had played in the workshop ensemble from which the Experimental Band emerged."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en242",
      "id": "en242r"
    }
  }, [_vm._v("223")])]), _vm._v(" The other cofounder, trumpeter Philip Cohran, did not belong to the Experimental Band, but he had spent two years working with another forward-looking ensemble, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p32"
    }
  }), _vm._v("Sun Ra’s Arkestra, which was based in Chicago until 1960."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en243",
      "id": "en243r"
    }
  }, [_vm._v("224")])]), _vm._v(" Moreover, like his colleague Abrams, Cohran was a self-made intellectual and respected teacher who freely shared his discoveries with younger musicians."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en244",
      "id": "en244r"
    }
  }, [_vm._v("225")])]), _vm._v(" The involvement of Abrams and Cohran ensured that interest in the nascent organization would be high. By May 1965, Abrams, Christian, Cohran, and McCall were ready to launch their organization. They mailed postcard announcements to many of the leading African American musicians in Chicago, and dozens showed up for the organization’s first meeting, held at Cohran’s residence near 75th Street and Cottage Grove."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en245",
      "id": "en245r"
    }
  }, [_vm._v("226")])])]), _vm._v(" "), _c('p', [_vm._v("There were fourteen items on the agenda for the inaugural meeting, but one item—“original music”—inspired more discussion than all the others combined."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en246",
      "id": "en246r"
    }
  }, [_vm._v("227")])]), _vm._v(" The musicians who attended the meeting were employed by nightclubs and lounges where they played the standard jazz repertoire, not their own compositions. Club dates could be tiresome even when they paid well, and the sudden decline of the South Side had made lucrative gigs harder to find than ever before. For many musicians, playing the same standard tunes night after night felt like driving down a dead-end street, and now the road was falling into disrepair. Instead of trying to fix this decaying infrastructure, Abrams and his colleagues wanted to replace it entirely. The solution they envisioned was a musicians’ collective that could provide an alternative to the nightclub scene. In this collective organization, members would work together to produce concerts of music they composed themselves. Presenting original compositions in a concert setting was an opportunity rarely granted to African American musicians, and those present at the meeting knew that they could achieve this goal only through collective effort."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en247",
      "id": "en247r"
    }
  }, [_vm._v("228")])])]), _vm._v(" "), _c('p', [_vm._v("As the meeting continued, the attendees began to develop a broader understanding of original music, one that would become essential to the organization’s self-conception."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en248",
      "id": "en248r"
    }
  }, [_vm._v("229")])]), _vm._v(" Mere originality, they concluded, was not enough. At the most basic level, writing an original composition could be as simple as crafting a new melody to fit an existing chord progression—something these musicians did every time they played a solo over a jazz standard. From their perspective, musical creativity was far more important than originality. Indeed, some original music could be rather ordinary, but the compositions and improvisations of “creative musicians” came from personal engagement with a source of spiritual inspiration."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en249",
      "id": "en249r"
    }
  }, [_vm._v("230")])]), _vm._v(" As saxophonist Gene Easton asserted, “creative music can only be original anyway, in a true creative sense.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en250",
      "id": "en250r"
    }
  }, [_vm._v("231")])]), _vm._v(" Certain musicians at the meeting found inspiration by delving into cutting-edge experimental music, while others explored ancestral forms, styles of music once played in the southern United States or even in Africa. More than a few of those present that day "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p33"
    }
  }), _vm._v("in May 1965 had already been changed by their studies of creative music. By the meeting’s end, it was clear that no one in the room would ever be the same.")]), _vm._v(" "), _c('p', [_vm._v("Enthusiasm ran high after the first meeting, and before long the organization was up and running. In a few weeks’ time, the members had elected Abrams as president and chosen eleven more officers and directors, many of whom belonged to the Experimental Band. They also gave the organization a name: the Association for the Advancement of Creative Musicians (AACM). One of the most urgent issues facing the AACM’s new leadership was financing. The AACM needed money to present concerts, and the cofounders debated whether they should solicit funds from local businesses and other institutions. However, they ultimately settled on a self-financing model in which the Association would pay for its operations with member dues and concert ticket sales. The members wanted to create a space for experimentation in an industry that was indifferent at best to noncommercial black music, and they were wary of being co-opted by funders with other agendas."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en251",
      "id": "en251r"
    }
  }, [_vm._v("232")])])]), _vm._v(" "), _c('p', [_vm._v("For similar reasons, they agreed that only African Americans would be permitted to join the AACM."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en252",
      "id": "en252r"
    }
  }, [_vm._v("233")])]), _vm._v(" In Chicago and throughout the country, social tensions related to the civil rights struggle were making it difficult for white and black Americans to collaborate, even on matters of shared interest. This was no less true for musicians. The New York–based Jazz Composers Guild, an interracial musicians’ collective founded a few months before the AACM, had already fragmented due to mistrust between its black and white members."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en253",
      "id": "en253r"
    }
  }, [_vm._v("234")])]), _vm._v(" Yet another racial conflict was unfolding closer to home. For more than sixty years, Chicago had two musicians’ unions, both affiliated with the American Federation of Musicians: white performers belonged to Local 10, and black performers belonged to Local 208."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en254",
      "id": "en254r"
    }
  }, [_vm._v("235")])]), _vm._v(" The Civil Rights Act of 1964 outlawed segregation in trade unions, and the two locals were ordered to merge. As many members of Local 208 predicted, the merger was largely ineffective in helping African American musicians secure gigs that had been off-limits during the era of segregation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en255",
      "id": "en255r"
    }
  }, [_vm._v("236")])]), _vm._v(" Moreover, once the merger was complete, the integrated Local 10–208 enriched itself by selling Local 208’s South Side headquarters, erasing the union’s connection to the black community."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en256",
      "id": "en256r"
    }
  }, [_vm._v("237")])]), _vm._v(" These cautionary examples were fresh in the minds of the AACM’s leaders when they decided to limit membership eligibility to African Americans. In their view, a racially restrictive membership policy seemed to be a prudent strategy, the best way to achieve the Association’s goal of empowering black musicians. The AACM, according to Abrams, was not interested in “fighting a racial fight”: “We’re promoting ourselves and helping ourselves up to the point where we can participate in the universal aspect of things, which includes all people.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en257",
      "id": "en257r"
    }
  }, [_vm._v("238")])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p34"
    }
  }), _vm._v("The state of Illinois accepted the AACM’s application to become a registered nonprofit corporation in August 1965, just three months after the musicians held their first meeting."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en258",
      "id": "en258r"
    }
  }, [_vm._v("239")])]), _vm._v(" As part of their application, Abrams and his fellow cofounders submitted a soon-to-be-famous list of nine purposes, the aims that would guide all of the Association’s future activities:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "bqnlf"
  }, [_vm._v("1. To cultivate young musicians and to create music of a high artistic level for the general public through the presentation of programs designed to magnify the importance of creative music.")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("2. To create an atmosphere conducive to artistic endeavors for the artistically inclined by maintaining a workshop for the express purpose of bringing talented musicians together.")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("3. To conduct a free training program for young aspirant musicians.")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("4. To contribute financially to the programs of the Abraham Lincoln Center, 700 E. Oakwood Blvd., Chicago, Ill., and other charitable organizations.")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("5. To provide a source of employment for worthy creative musicians.")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("6. To set an example of high moral standards for musicians and to uplift the public image of creative musicians.")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("7. To increase mutual respect between creative artists and musical tradesmen (booking agents, managers, promoters and instrument manufacturers, etc.).")]), _vm._v(" "), _c('li', {
    staticClass: "bqnl"
  }, [_vm._v("8. To uphold the tradition of cultured musicians handed down from the past.")]), _vm._v(" "), _c('li', {
    staticClass: "bqnll"
  }, [_vm._v("9. To stimulate spiritual growth in creative artists through recitals, concerts, etc., through participation in programs."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiSteinbeckupdate0020#en259",
      "id": "en259r"
    }
  }, [_vm._v("240")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("A few of the nine purposes were directly related to the members’ needs: the AACM would produce concerts, sponsor a musical workshop (the Experimental Band), and encourage creative pursuits that aided the members’ “spiritual growth.” Most of the purposes, however, spoke not to the membership but to the African American community on the South Side—the AACM’s family, friends, and neighbors. The members of the Association were deeply rooted in Bronzeville, and they realized that they could not advance creative music without contributing to the community from which it arose. With these nine purposes, the AACM declared that it was going to be much more than a musicians’ collective. AACM members saw themselves as community organizers, charged with transforming society through the power of creative music.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23545df6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-Steinbeck-update-0009.vue
// module id = 78
// module chunks = 0